import { useContext, useState, useEffect } from 'react';
import CustomizerContext from '../../../../_helper/Customizer';
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate';
import {useParams, useNavigate } from "react-router-dom";

type RouteParams = {
    tabName?: string;
};

export default function useFinanceManagementAccountReportSettings() {    
    const { layoutURL } = useContext(CustomizerContext);
    const axiosPrivate = useAxiosPrivate();
    const FINANCE_MA_REPORT_CLASS = 'ma-report-classes';
   /*  const GRADE = 'grades';
    const STEP = 'steps';
    const GRADE_STEP = 'grade-steps'; */
    
    const navigate = useNavigate();
    const { tabName } = useParams<RouteParams>();  
    const [commissionTab, setCommissionTab] = useState<string>(tabName || `${FINANCE_MA_REPORT_CLASS}`); 
    
    const tabDisplayNames: { [key: string]: string } = {
        'ma-report-classes': 'Finance Management Account Report Class',
       /*  'grades': 'Grade',
        'steps': 'Step',
        'grade-steps': 'Grade Step', */
      };

    useEffect(() => {
        if (tabName && tabName !== commissionTab) {
            setCommissionTab(tabName);
        }
    }, [tabName]);

    const handleTabClick = (routeName: string) => {
        setCommissionTab(routeName);
        navigate(`/finance/settings/${routeName}/${layoutURL}`); // Append to route
    };

    return {
        layoutURL,
        FINANCE_MA_REPORT_CLASS,
        /* GRADE, 
        STEP,
        GRADE_STEP,*/
        commissionTab,
        tabDisplayNames,
        handleTabClick
    };
}
